var $j = jQuery.noConflict();


$j(document).ready(function ($) {

    $j('.playlistoverview__medias .dropdown-menu__alllinks').css('height', windowsHeight + 'px');

    $(window).resize(function (e) {
        $j('.bs-slides .current .background-block').width('auto');
        $j('.bs-slides .current .background-block').height('auto');
        resizeBigSliderContainer();
        var heightCalculatedResize = $j('.big-slider').width() * 600 / 1240;
        $j('.bs-content-slide').css({
            height: heightCalculatedResize > 290 ? heightCalculatedResize : 290
        });
    });
    // setSliders();
    $j(".btn-openclose").on("click", function () {
        openCloseMenu();
    });

    // Ouvre/Ferme le menu mobile et focus l'input de recherche
    $j(".btn-opensearch").on("click", function () {
        openCloseMenu();
        $j("#inputsearch-mobile").focus();
    });

    var heightCalculated = $j('.big-slider').width() * 600 / 1240;
    $j('.bs-content-slide').css({
        height: heightCalculated > 290 ? heightCalculated : 290
    });

    $j('.fakeinputbox-me').fakeInputBox();
    $j('select.fake-select').FakeSelect();
    $j('[placeholder]').FakePlaceholder();

    $j(".benefit__icon").on("click", function () {
        $j(".benefit")
            .removeClass("active");
        $j(this)
            .closest(".benefit")
            .addClass("active");
    });

    // Hovers dropdown
    if (windowWidth() > 992) {
        $j('.main-header__links').children(".has-dropdown").hover(function () {
            $j(this)
                .addClass("open");
        }, function () {
            $j(this)
                .removeClass("open");
        });
    }
    if (windowWidth() < 991) {
        $j('.has-dropdown').click(function () {
            $j(this).toggleClass("test");
        });
    }

    // Search Filters
    $j(".filtres-actives button").on("click", function () {
        $(this).hide();
    });

    $j(".ordres-actives select").on('change', function () {
		var currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('order', $(this).val());
        window.location = currentUrl.href;
	});

    // Grid / List search

    $j("#grid-mode").on("click", ".cssc-button--gridmod", function () {
        var searchItems = $j("#search-items, #top-items"),
            item = $j(this),
            idButton = item.attr("id");

        if (!item.hasClass("is-active")) {
            $j(".cssc-button--gridmod").removeClass("is-active");
            item.addClass("is-active");

            if (idButton == "gridmod-grid") {
                searchItems.addClass("search-items--grid");
                searchItems.removeClass("search-items--list");
                jQuery('.counter-label').removeAttr('style');

            } else {
                searchItems.removeClass("search-items--grid");
                searchItems.addClass("search-items--list");
                jQuery('.counter-label').css('display', 'none');
            }
        }
    });

    // Collections 
    $j(".collection-thumbs-item").click(function () {
        if (windowWidth() > 767) {
            var collectionMain = $j(".collection-main").html();
            var htmlString = $j(this).html();
            $j(".collection-main").animate({ "opacity": "0.5" }, "slow").html(htmlString).animate({ "opacity": "1" }, "slow");
            $j(this).animate({ "opacity": "0.5" }, "slow").html(collectionMain).animate({ "opacity": "1" }, "slow");
        }
    });

    // Open close categories

    $j("#search-activecategory").on("click", function () {
        hideShowThings($j(this));
    });
    jQuery(window).on('resize', function () {
        if (windowWidth() > 767) {
            $("#search-activecategory").css("display", "inline-block");
            $(".editorialfeednav").css("display", "none");
        }
    });
    jQuery(window).on('resize', function () {
        if (windowWidth() > 992) {
            $(".editorialfeednav").css("display", "inline-block");
        }
    });
    // Open / Close filters

    const $titleFilters = document.querySelectorAll('.search-filtres__category .title');
    $titleFilters.forEach($titleFilter => $titleFilter.addEventListener('click', (e) => {
        if (e.target.classList.contains('title')) {
            $titleFilter.classList.toggle('is-open');
            $titleFilters.forEach($subTitleFilter => {
                if ($subTitleFilter !== $titleFilter) {
                    $subTitleFilter.classList.remove('is-open');
                }
            })
        }
    }));

    const $toggleFilterPanelButttons = document.querySelectorAll('.toggle-filter-panel');
    $toggleFilterPanelButttons.forEach($toggleFilterPanelButtton => $toggleFilterPanelButtton.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('body').classList.toggle('filter-panel-opened')
    }))

    // $j("#search-filtres__category").on("click", ".title", function () {
    //     console.log(this, 'test')
    //     $j(this).toggleClass('is-open')
    // });

    // Open / Close Filters (list)

    $j("#search-filtres__title").on("click", function () {
        hideShowThings($j(this));
    });
    // jQuery(window).on('resize', function () {
    //     if (windowWidth() > 767) {
    //         $("#search-filtres__category").css("display", "flex");
    //     }
    // });

    // $j(".search-item__syno").each(function(i, el) {
    //     truncateText($j(el));
    // });

    resizeSliders(windowWidth());

    $j(".carousel").swiperight(function () {
        if( !$(this).hasClass('carousel-articles-reviews') || ($(this).hasClass('carousel-articles-reviews') && $(window).width() >= 992)) {
            $j(this).carousel('prev');
        }
    });

    $j(".carousel").swipeleft(function () {
        if( !$(this).hasClass('carousel-articles-reviews') || ($(this).hasClass('carousel-articles-reviews') && $(window).width() >= 992)) {
            $j(this).carousel('next');
        }
    });

    // Delete playlists

    $j(".btn-delete-playlist").on("click", function () {
        $j(this)
            .closest(".delete")
            .toggleClass("is-open")
            .closest(".media-body")
            .find(".playlistoverview__item-hover")
            .toggleClass("is-selected");
    });

    $j(".playlistoverview__item-hover").on("click", function () {
        if ($j(this).hasClass("is-selected")) {
            $j(this)
                .addClass("deleting")
                .parent()
                .delay(600)
                .slideUp(500);
        }
    });

    // Lightbox critiques

    $j("#review-list-block").on("click", ".cc-main-link", function () {
        var nameLightbox = $j(this).attr("data-name");
        $j("#review-lightbox")
            .fadeIn(300, function () {
                $j(this)
                    .find(".review-lightbox__modal[data-name=" + nameLightbox + "]")
                    .addClass("is-open");
            });
        return false;
    });

    $j(".review-lightbox__modal").on("click", ".cssc-button", function () {
        $j(".review-lightbox__modal")
            .removeClass("is-open")
            .delay(600)
            .closest("#review-lightbox")
            .fadeOut("300");
    });

    // Click checkout (achat / location)

    $j(".checkout-cart__checkbox").on("change", "input[type=radio]", function () {
        $j(this)
            .closest("tr")
            .find(".checkout-cart__checkbox")
            .addClass("is-inactive");
        $j(this)
            .closest(".checkout-cart__checkbox")
            .removeClass("is-inactive");
    });

    // Click checkout (méthode de paiement)

    $j(".payment").on("change", "input[type=radio]", function () {
        $j(".payment")
            .addClass("is-inactive");
        $j(this)
            .closest(".payment")
            .removeClass("is-inactive");
    });

    // Clicks modal

    $j(".modal-switch-button").on("click", function () {
        $j(this)
            .closest(".modal")
            .modal("hide");
    });

    $j(".checkParentalCode").on("click", function () {
        $j('.btnParentalCodeValid').data('href', $j(this).data('href'));
    });

    $j('.btnParentalCodeValid').on('click', function () {
        $j.ajax({
            url: Routing.generate('ajax_check_parental_code', {'parentalCode': $j('.inputParentalCode').val()}),
            type: "POST",
            success: function (data) {
                if (data.result) {
                    document.location.href = $j('.btnParentalCodeValid').data('href');
                } else {
                    $j('.errorParentalCode').show();
                }
            },
        });
    });

    // Unbind click to close dropdownmenu

    $j('.dropdown-menu input, .dropdown-menu label').click(function (e) {
        e.stopPropagation();
    });

    // Playlist Img loaded
    setTimeout(function () {
        var windowsHeigh = $j('.playlistoverview__medias img').height();
        $j('.playlistoverview__medias .dropdown-menu__alllinks').css('height', windowsHeigh + 'px');
    }, 600);

});

$j(window).smartresize(function () {
    resizeSliders(windowWidth());
});

$j(window).on("scroll", function () {
    if (windowWidth() > 975) {
        var bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        scrollMenu(bodyScrollTop);
    }
});

//when resizing the site, we adjust the heights of the sections
$j(window).resize(function () {
    setDimensions();
});

var windowsHeight = $j('.playlistoverview__medias img').height();
$j('.playlistoverview__medias .dropdown-menu__alllinks').css('height', windowsHeight + 'px');
